<script lang="ts">
	import { resolve } from '$app/paths';
	// NOTE: Skel 4's <Avatar /> is a compositional anatomy (Root/Image/Fallback);
	// the Skel 2 single-element `<Avatar src width border />` API silently drops
	// src/width/border and renders an empty <div>, causing the header avatar to
	// disappear (02-06 fixup, Rule 1). Use a plain <img> for minimum-edit.
	import Popup from '$components/Popup.svelte';

	interface Props {
		classes?: string;
		src?: string;
		logged?: boolean;
		children?: import('svelte').Snippet;
	}

	let {
		classes = '',
		src = '/static/images/thumbnails/default-user.jpg',
		logged = false,
		children
	}: Props = $props();

	let triggerEl: HTMLDivElement = $state()!;
	let popupOpen = $state(false);

	function handleClickOutside(e: MouseEvent) {
		if (!triggerEl) return;
		const target = e.target as Node;
		if (triggerEl.contains(target)) return;
		popupOpen = false;
	}
</script>

<svelte:window onclick={handleClickOutside} />

{#if logged}
	<div
		bind:this={triggerEl}
		role="button"
		tabindex="0"
		onclick={() => (popupOpen = !popupOpen)}
		onkeydown={(e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				popupOpen = !popupOpen;
			}
		}}
		class=""
	>
		<img
			{src}
			alt="avatar"
			class="h-8 w-8 rounded-full border-2 border-surface-50 object-cover hover:cursor-pointer hover:border-primary-500! active:border-primary-200! sm:h-10 sm:w-10 {classes}"
		/>
	</div>

	<Popup bind:open={popupOpen} {triggerEl} placement="bottom">
		{@render children?.()}
	</Popup>
{:else}
	<button class="rounded-full bg-primary-500 btn-sm py-1 text-white">
		<a class="hidden p-1 xl:block xl:text-base" href={resolve('/signin')}>Sign in/Sign up</a>
		<a class="text-sm md:text-base xl:hidden" href={resolve('/signin')}>Sign Up</a>
	</button>
{/if}
